import { inject, Injectable } from '@angular/core';
import {
    INxStatusProjectService,
    ProjectInfo,
    ProjectQuery,
    ProjectSummary,
    ProjectUpdateInfo,
} from '@dat/datiq-nx-repo-utils';
import { DatiqNxRepoClientApiService } from './datiq-nx-repo-client-api.service';
import { DatiqNxRepoClientStaticService } from './datiq-nx-repo-client-static.service';
import { USE_NX_TOOL_API } from './datiq-nx-repo-client.models';

@Injectable({
    providedIn: 'root',
})
export class DatiqNxRepoClientService implements INxStatusProjectService {
    private _useNxApi: boolean = inject<boolean>(USE_NX_TOOL_API);
    private _service: INxStatusProjectService = this._useNxApi
        ? inject(DatiqNxRepoClientApiService)
        : inject(DatiqNxRepoClientStaticService);

    constructor() {}

    async exportProject(
        fileType: string,
        query: ProjectQuery,
    ): Promise<string> {
        return this._service.exportProject(fileType, query);
    }
    
    async queryProjectKeys(query: ProjectQuery): Promise<string[]> {
        return this._service.queryProjectKeys(query);
    }

    async queryProjects(query: ProjectQuery): Promise<ProjectInfo[]> {
        return this._service.queryProjects(query);
    }
    async getProjectSummary(query: ProjectQuery): Promise<ProjectSummary> {
        return this._service.getProjectSummary(query);
    }
    async getProjects(): Promise<Record<string, ProjectInfo>> {
        return this._service.getProjects();
    }
    async getProject(project: string): Promise<ProjectInfo> {
        return this._service.getProject(project);
    }

    async updateProject(
        projectKey: string,
        projectInfo: Partial<ProjectUpdateInfo>,
    ): Promise<ProjectInfo> {
        return this._service.updateProject(projectKey, projectInfo);
    }
}
